import type { TopUpAmounts } from './types';

/**
 * The amount rules of «Поповнити онлайн» (owner, 2026-10-27), the same the server checks: a
 * ready amount under the minimum is not offered, an own amount from the minimum up with no top
 * limit, and none at all while «Своя сума» is off.
 */
export function offeredPresets(amounts: TopUpAmounts): number[] {
    return amounts.presets.filter((p) => p >= amounts.min);
}

export function canPay(amounts: TopUpAmounts, amount: number | null): boolean {
    // A minimum of 0 is «no minimum»: anything above nothing (owner, 2026-10-27).
    if (
        amount === null ||
        !Number.isFinite(amount) ||
        amount <= 0 ||
        amount < amounts.min
    ) {
        return false;
    }

    return amounts.custom || offeredPresets(amounts).includes(amount);
}

/** Where the payment stands, for the sheet: still going, done, or over without money. */
export function paymentPhase(status: string): 'waiting' | 'paid' | 'failed' {
    if (status === 'paid') {
        return 'paid';
    }

    return status === 'pending' || status === 'processing'
        ? 'waiting'
        : 'failed';
}
